export const TERMS_AND_CONDITIONS = "TERMS_CONDITIONS";

export const PRICING = "PRICING";

export const FUTURE_PRICING = "FUTURE_PRICING";

export const RESERVATION_DEPOSIT = "RESERVATION_DEPOSIT";

export const STORE_ID = "STORE_ID";

export const ACCESSORIES_PRICING = "ACCESSORIES_PRICING";

export const DELIVERY_BANDS = "DELIVERY_BANDS";

export const DELIVERY_BANDS_REQ = "DELIVERY_BANDS_REQ";

export const VARIABLE_MARKETING = "VM";

export const OPT_IN = "OPT_IN";

export const NONE = "NONE";

export const CHARGE = "CHARGE";

export const DISCOUNT = "DISCOUNT";

export const GPIS_PRICING = "GPIS_PRICING";

export const NEW_VEHICLE_LINE = "NEW_VEHICLE_LINE";

export const PRICE_CHANGE_INFO = "PRICE_CHANGE_INFO";

export const ALD_PRICING = "ALD_PRICING";

export const PAYMENT_THRESHOLD = "PAYMENT_THRESHOLD";

export const INCENTIVES_CHANGE = "INCENTIVES_CHANGE";

export const CUPID_ID = "CUPID_ID";

export const LEAD_TIMES = "LEAD_TIMES";

export const WALLBOX = "WALLBOX";

export const DEFAULT_VEHICLE = "MUSTANG MACH-E";

export const DEFAULT_YEAR = "2021";

export const CUSTOMER_CONTRACT = "CUSTOMER_CONTRACT";

export const ENGLISH = "en";

export const PAGE = "page";

export const BRAND = "brand";

export const SALESCODE_KEY = "sales.code";

export const ADFS_TOKEN = "adfs.token";

export const MARKET = "market";

export const CASH = "cash";

export const FINANCE = "finance";

export const LEASE = "lease";

export const OFFLINE_LEASE = "offline_lease";

export const OFFLINELEASE = "offline lease";

export const OFFLINE_FINANCE = "offline_finance";

export const OFFLINEFINANCE = "offline finance";

export const PRIVATE_LEASE = "private lease";

export const OFFLINE_PRIVATE_LEASE = "offline_private_lease";

export const OFFLINEPRIVATELEASE = "offline private lease";

export const DENIED = "DENIED";

export const ERROR = "ERROR";

export const OPT_OFFLINE = "OPT_OFFLINE";

export const TIMED_OUT = "TIMED_OUT";

export const FINANCE_REFERRED = "FINANCE_REFERRED";

export const FINANCE_EID_CHECKED_FAIL = "FINANCE_EID_CHECKED_FAIL";

export const PROPOSAL_EXPIRED = "PROPOSAL_EXPIRED";

export const ADDITIONAL_FEE = "additionalFee";
export const GROSS_DELIVERY_FEE = "grossDeliveryFee";
export const UNAVOIDABLE_COST = "unavoidableCost";
export const TOTAL_ROAD_READY_PRICE = "totalRoadReadyPrice";

export const FINANCE_PRODUCT_TYPE = {
  FINANCE: "finance",
  LEASE: "lease",
  FLEX_BUY: "flex buy",
  FORD_OPTIONS: "ford options",
  CASH: "cash",
  THIRD_PARTY: "finance",
  BUSINESS_CONTRACT_HIRE: "lease",
  OTHER: "other financing options",
};

export const DELIVERY = "delivery";

export const SCRAP_FEE = "scrapFee";

export const REG_TAX = "baseRegistrationTax";

export const REG_FEE = "registrationFee";

export const NA_DEFAULT_CURRENCY = "$";

export const CANCELLED = "CANCELLED";

export const ACCEPTED = "ACCEPTED";

export const SUBMITTED = "SUBMITTED";

export const OFFLINEDOCSIGN = "offlineDocsign";

export const PARTIALOFFLINE = "partialOfflinePriceUpdate";

export const FINANCED = "FINANCED";

export const LEASED = "LEASED";

export const OWNED = "OWNED";
export const REJECT = "reject";
export const DECISION = "decision";
export const INCLUDED = "included";
export const SELECTED = "selected";

export const BNPP = "BNPP";
export const AL = "AL";
export const PERSONAL = "PERSONAL";
export const ORGANIZATION = "ORGANIZATION";
export const BUSINESS = "BUSINESS";
export const ORGANIZATION_TYPE = "Organization";
export const ACCESSORIES_VERSION = {
  GBR: 1,
  FRA: 1,
  NOR: 3,
  NLD: 1,
  CHE: 1,
  DEU: 1,
  ESP: 3,
  ITA: 3,
  AUT: 3,
  BEL: 3,
  FIN: 3,
  DNK: 3,
  CZE: 2,
  POL: 2,
  IRL: 4,
  HUN: 3,
  GRC: 3,
  ROU: 3,
  PRT: 3,
};

const DEFAULT_FINANCE_FLOW = [
  {
    key: "financeContract",
    previousKey: null,
    hasPrevious: false,
  },
  {
    key: "customerDownPayment",
    previousKey: "financeContract",
    hasPrevious: true,
  },
  {
    key: "financePayment",
    previousKey: "customerDownPayment",
    hasPrevious: true,
  },
];
export const FINANCE_OPTIONS = {
  APPROVED: "APPROVED",
  SIGNING: "SIGNING",
  SIGNED: "SIGNED",
  COMPLETED: "COMPLETED",
  FINANCE_REFERRED: "FINANCE_REFERRED",
  CANCELLED: "CANCELLED",
  WETSIGN_OFFLINE: "WETSIGN_OFFLINE",
  FINANCE_CONTRACT: "contractwetsigned",
  CUSTOMER_DOWN_PAYMENT: "downpaymentpaidoffline",
  FINANCE_PAYMENT_CONFIRMED: "finalpaymentconfirmed",
  ONLINE_APPROVED_MARKETS: ["GBR", "FRA", "NOR", "DEU", "ITA", "ESP"],
  GBR: [
    {
      key: "registrationNumber",
      previousKey: null,
      hasPrevious: false,
    },
    {
      key: "uploadDealerInvoice",
      previousKey: "registrationNumber",
      hasPrevious: true,
    },
    {
      key: "financeContract",
      previousKey: "uploadDealerInvoice",
      hasPrevious: true,
    },
    {
      key: "customerDownPayment",
      previousKey: "financeContract",
      hasPrevious: true,
    },
    {
      key: "financePayment",
      previousKey: "customerDownPayment",
      hasPrevious: true,
    },
  ],
  FRA: [
    {
      key: "financeContract",
      previousKey: null,
      hasPrevious: false,
    },
    {
      key: "customerDownPayment",
      previousKey: "financeContract",
      hasPrevious: true,
    },
    {
      key: "registrationNumber",
      previousKey: "customerDownPayment",
      hasPrevious: true,
    },
    {
      key: "uploadDealerInvoice",
      previousKey: "registrationNumber",
      hasPrevious: true,
    },
  ],
  NLD: [
    {
      key: "openPaymentWindow",
      previousKey: null,
      hasPrevious: false,
    },
    {
      key: "customerFullPayment",
      previousKey: "openPaymentWindow",
      hasPrevious: true,
    },
  ],
  NOR: DEFAULT_FINANCE_FLOW,
  DEU: DEFAULT_FINANCE_FLOW,
  ITA: DEFAULT_FINANCE_FLOW,
  ESP: DEFAULT_FINANCE_FLOW,
};

const DEFAULT_CASH_FLOW = [
  {
    key: "acceptTheOrder",
    previousKey: false,
    hasPrevious: false,
  },
  {
    key: "openPaymentWindow",
    previousKey: "acceptTheOrder",
    hasPrevious: true,
  },
  {
    key: "customerFullPayment",
    previousKey: "openPaymentWindow",
    hasPrevious: true,
  },
];
export const CASH_OPTIONS = {
  ACCEPT_ORDER: "accepttheorder",
  CUSTOMER_DOWN_PAYMENT: "offlineeudownpayment",
  FINAL_PAYMENT_CONFIRMED: "finalPaymentConfirmed",
  FINANCE_PAYMENT_CONFIRMED: "finalpaymentconfirmed",
  ONLINE_APPROVED_MARKETS: ["GBR", "FRA", "NOR", "CHE", "NLD", "DEU"],
  GBR: DEFAULT_CASH_FLOW,
  FRA: DEFAULT_CASH_FLOW,
  NOR: DEFAULT_CASH_FLOW,
  CHE: DEFAULT_CASH_FLOW,
  DEU: DEFAULT_CASH_FLOW,
  NLD: DEFAULT_CASH_FLOW,
};

const DEFAULT_LEASE_OPTIONS = [
  {
    key: "leaseContractSigned",
    previousKey: null,
    hasPrevious: false,
  },
  {
    key: "leasePayBalence",
    previousKey: "leaseContractSigned",
    hasPrevious: true,
  },
  {
    key: "leasePayment",
    previousKey: "leasePayBalence",
    hasPrevious: true,
  },
];
export const LEASE_OPTIONS = {
  COMPLETED: "COMPLETED",
  LEASE_CONTRACT: "contractwetsigned",
  LEASE_OFFLINE_BALANCE_PAYMENT: "offlinebalancepayment",
  LEASE_PAYMENT_CONFIRMED: "finalpaymentconfirmed",
  OFFLINE_APPROVED_MARKETS: ["GBR", "FRA", "DEU", "NLD", "ITA", "ESP"],
  ONLINE_APPROVED_MARKETS: ["GBR", "FRA", "DEU", "NLD", "ITA", "ESP"],
  LEASE_CONTRACT_AUTO_TICK: ["GBR", "ITA", "ESP"],
  GBR: [
    {
      key: "leaseContractSigned",
      previousKey: null,
      hasPrevious: false,
    },
    {
      key: "registrationNumber",
      previousKey: null,
      hasPrevious: false,
    },
    {
      key: "leaseContractSignedOnline",
      previousKey: "registrationNumber",
      hasPrevious: true,
    },
    {
      key: "leasePayBalence",
      previousKey: "leaseContractSignedOnline",
      hasPrevious: true,
    },
    {
      key: "dealerInvoice",
      previousKey: "leasePayBalence",
      hasPrevious: true,
    },
    {
      key: "certificateRegistration",
      previousKey: "dealerInvoice",
      hasPrevious: true,
    },
    {
      key: "deliveryNotes",
      previousKey: "certificateRegistration",
      hasPrevious: true,
    },
    {
      key: "leasePayment",
      previousKey: "deliveryNotes",
      hasPrevious: true,
    },
  ],
  FRA: DEFAULT_LEASE_OPTIONS,
  NLD: DEFAULT_LEASE_OPTIONS,
  DEU: DEFAULT_LEASE_OPTIONS,
  ITA: DEFAULT_LEASE_OPTIONS,
  ESP: DEFAULT_LEASE_OPTIONS,
};

export const LANGUAGE_MARKET_MAP = {
  GBR: "en_GB",
  FRA: "fr_FR",
  NOR: "no_NO",
  NLD: "nl_NL",
  CHE: "de_CH",
  DEU: "de_DE",
  ESP: "es_ES",
  ITA: "it_IT",
  AUT: "de_AT",
  BEL: "fr_BE",
  FIN: "fi_FI",
  DNK: "da_DK",
  USA: "en_US",
  CAN: "en_CA",
  CZE: "cs_CZ",
  POL: "pl_PL",
  IRL: "en_IE",
  HUN: "hu_HU",
  GRC: "el_GR",
  ROU: "ro_RO",
  PRT: "pt_PT",
};

export const LANGUAGE_MARKET_MAP_FULL = {
  GBR: "en_GB",
  FRA: "fr_FR", // Corrected
  NOR: "no_NO", // Corrected
  NLD: "nl_NL", // Corrected
  CHE: "de_CH",
  DEU: "de_DE", // Corrected
  ESP: "es_ES",
  ITA: "it_IT",
  AUT: "de_AT",
  BEL: "fr_BE",
  FIN: "fi_FI",
  DNK: "da_DK",
  USA: "en_US",
  CAN: "en_CA",
  CZE: "cs_CZ",
  POL: "pl_PL",
  IRL: "en_IE",
  HUN: "hu_HU",
  GRC: "el_GR",
  ROU: "ro_RO",
  PRT: "pt_PT",
};

export const FEES_MAP = {
  GBR: [
    {
      key: "roadFundLicense",
      name: "DealerFees.roadFundLicense",
      isEditable: false,
    },
    {
      key: "firstRegFee",
      name: "DealerFees.firstRegFee",
      isEditable: false,
    },
    {
      key: "numberPlates",
      name: "DealerFees.numberPlates",
      isEditable: true,
    },
    {
      key: "additionalFees",
      name: "DealerFees.additionalFees",
      isEditable: true,
    },
  ],
  ESP: [
    {
      key: "cityFee",
      name: "DealerFees.cityFee",
      isEditable: true,
    },
    {
      key: "handlingFee",
      name: "DealerFees.handlingFee",
      isEditable: true,
    },
    {
      key: "additionalFees",
      name: "DealerFees.additionalFees",
      isEditable: true,
    },
  ],
  ITA: [
    {
      key: "deliveryFee",
      name: "DealerFees.handlingAndDeliveryFee",
      isEditable: true,
    },
    {
      key: "additionalFees",
      name: "DealerFees.additionalFees",
      isEditable: true,
    },
  ],
  AUT: [
    {
      key: "firstRegFee",
      name: "DealerFees.regFee",
      isEditable: true,
    },
    {
      key: "deliveryFee",
      name: "DealerFees.handlingAndDeliveryFee",
      isEditable: true,
    },
    {
      key: "additionalFees",
      name: "DealerFees.additionalFees",
      isEditable: true,
    },
  ],
  BEL: [
    {
      key: "handlingFee",
      name: "DealerFees.handlingFee",
      isEditable: true,
    },
    {
      key: "additionalFees",
      name: "DealerFees.additionalFees",
      isEditable: true,
    },
  ],
  FIN: [
    {
      key: "deliveryFee",
      name: "DealerFees.handlingAndDeliveryFee",
      isEditable: true,
    },
    {
      key: "additionalFees",
      name: "DealerFees.additionalFees",
      isEditable: true,
    },
    {
      key: "registrationTax",
      name: "DealerFees.registrationTax",
      isEditable: false,
    },
  ],
  DNK: [
    {
      key: "numberPlates",
      name: "DealerFees.numberPlates",
      isEditable: false,
    },
    {
      key: "deliveryFee",
      name: "DealerFees.handlingAndDeliveryFee",
      isEditable: false,
    },
    {
      key: "additionalFees",
      name: "DealerFees.additionalFees",
      isEditable: true,
    },
  ],
  DEU: [
    {
      key: "deliveryFee",
      name: "DealerFees.handlingAndDeliveryFee",
      isEditable: true,
    },
    {
      key: "firstRegFee",
      name: "DealerFees.regFee",
      isEditable: true,
    },
    {
      key: "numberPlates",
      name: "DealerFees.numberPlates",
      isEditable: true,
    },
    {
      key: "additionalFees",
      name: "DealerFees.additionalFees",
      isEditable: true,
    },
  ],
  FRA: [
    {
      key: "deliveryFee",
      name: "DealerFees.handlingAndDeliveryFee",
      isEditable: true,
    },
    {
      key: "firstRegFee",
      name: "DealerFees.regFee",
      isEditable: true,
    },
    {
      key: "malusFee",
      name: "DealerFees.malusFee",
      isEditable: true,
    },
    {
      key: "numberPlates",
      name: "DealerFees.numberPlates",
      isEditable: true,
    },
    {
      key: "additionalFees",
      name: "DealerFees.additionalFees",
      isEditable: true,
    },
  ],
  NOR: [
    {
      key: "deliveryFee",
      name: "DealerFees.deliveryFee",
      isEditable: true,
    },
    {
      key: "firstRegFee",
      name: "DealerFees.regFee",
      isEditable: false,
    },
    {
      key: "registrationTax",
      name: "DealerFees.registrationTax",
      isEditable: false,
    },
    {
      key: "additionalFees",
      name: "DealerFees.additionalFees",
      isEditable: true,
    },
  ],
  NLD: [
    {
      key: "unavoidableCost",
      name: "DealerFees.unavoidableCost",
      isEditable: false,
    },
    {
      key: "additionalFees",
      name: "DealerFees.additionalFees",
      isEditable: true,
    },
  ],
  CHE: [
    {
      key: "deliveryFee",
      name: "DealerFees.handlingAndDeliveryFeeInclReg",
      isEditable: true,
    },
    {
      key: "additionalFees",
      name: "DealerFees.additionalFees",
      isEditable: true,
    },
  ],
  CZE: [
    {
      key: "firstRegFee",
      name: "DealerFees.firstRegFee",
      isEditable: true,
    },

    {
      key: "additionalFees",
      name: "DealerFees.additionalFees",
      isEditable: true,
    },
  ],
  POL: [
    {
      key: "firstRegFee",
      name: "DealerFees.firstRegFee",
      isEditable: true,
    },

    {
      key: "additionalFees",
      name: "DealerFees.additionalFees",
      isEditable: true,
    },
  ],

  IRL: [
    {
      key: "roadFundLicense",
      name: "DealerFees.roadFundLicense",
      isEditable: false,
    },
    {
      key: "additionalFees",
      name: "DealerFees.additionalFees",
      isEditable: true,
    },
  ],
  HUN: [
    {
      key: "additionalFees",
      name: "DealerFees.additionalFees",
      isEditable: true,
    },
  ],
  GRC: [
    {
      key: "firstRegFee",
      name: "DealerFees.firstRegFee",
      isEditable: true,
    },
    {
      key: "additionalFees",
      name: "DealerFees.additionalFees",
      isEditable: true,
    },
  ],
  ROU: [
    {
      key: "additionalFees",
      name: "DealerFees.additionalFees",
      isEditable: true,
    },
  ],
  PRT: [
    {
      key: "registrationTax",
      name: "DealerFees.registrationTax",
      isEditable: false,
    },
    {
      key: "additionalFees",
      name: "DealerFees.additionalFees",
      isEditable: true,
    },
  ],
};

export const SIGN_NOT_SELECTED = "SIGN_NOT_SELECTED";
export const SIGN_OFFLINE = "SIGN_OFFLINE";

export const BEV_VEHICLES = ["MUSTANG MACH-E"];

export const SRP_PRICE_TYPE = "SRP";

export const CHECURRENCY = "CHF";

export const GPRS_ERROR_MESSAGE = "Error retrieving pricing data from GPRS";

export const PURCHASE_REQUEST_ACCEPTED = "purchaserequestaccepted";

export const CONDITIONED_CREDIT_APP = "CONDITIONED";
export const APPROVED = "APPROVED";
export const COMMERCIAL_SEGMENT = "Commercial";
export const REFERRED = "REFERRED";
export const CREATED = "created";

export const PURCHASE_REQUEST_STATUS = {
  CREATED: "CREATED",
  SOLD: "SOLD",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
  PENDING: "PENDING",
  CANCELLED: "CANCELLED",
};
export const SAP_ORDER_STATUS = {
  CREATED: "CREATED",
  CONTRACT_REQUESTED: "CONTRACT_REQUESTED",
  CANCELLED: "CANCELLED",
};
export const GOMS_FLOW_STATUS = [
  "OREC",
  "USCH",
  "OCAN",
  "CMTD",
  "BWKA",
  "OSEQ",
  "STRT",
  "VDOS",
  "VSHP",
  "PROD",
  "IPRL",
  "GRTA",
  "VASC",
  "VITR",
  "VPRT",
  "VHLG",
  "VETL",
  "VMOD",
  "VCRB",
  "VAND",
  "VCMP",
  "VEHS",
  "VAFD",
  "VPHD",
];
export const COMPLETED = "COMPLETED";

// Progress Tracker
// 0: Order Placed, 1: In Production, 2: Shipping, 3: Delivery
export const ORDER_STATUS = {
  0: ["orec", "usch", "ocan", "cmtd", "bwka", "oseq"],
  1: ["strt", "vdos", "vshp", "prod", "iprl", "grta", "vasc"],
  2: [
    "vprt",
    "vhlg",
    "vetl",
    "vmod",
    "vcrb",
    "vand",
    "vcmp",
    "vehs",
    "vafd",
    "vphd",
    "vitr",
  ],
};
//0: Pre-Order Placed, 1: Order Placed, 2: In Production, 3: On Its Way, 4: Delivered
export const RESERVATION_STATUS = {
  2: ["strt", "vdos", "vshp", "prod", "iprl", "grta", "vasc"],
  3: [
    "vprt",
    "vhlg",
    "vetl",
    "vmod",
    "vcrb",
    "vand",
    "vcmp",
    "vehs",
    "vafd",
    "vphd",
    "vitr",
  ],
};

export const DECIMAL_PLACES = 2;
export const MARKET_LANGUAGES = {
  BEL: ["nl", "fr"],
  CHE: ["fr", "de"],
  NLD: ["nl", "en"],
  CAN: ["en", "fr"],
};
export const LANCODES = {
  en: "ENGLISH",
  fr: "FRENCH",
  de: "GERMAN",
  nl: "DUTCH",
  no: "NORWEGIAN",
  es: "SPANISH",
  it: "ITALIAN",
  fi: "FINNISH",
  da: "DANISH",
  pl: "POLISH",
  ir: "IRISH",
  cs: "CZECH",
  hu: "HUNGARIAN",
  gr: "GREEK",
  ro: "ROMANIAN",
  pt: "PORTUGUESE",
  el: "GREEK",
};

// Regions for translation tool
export const TRANSLATION_TOOL_REGIONS = {
  EU: [
    "GBR",
    "AUT",
    "DEU",
    "CHE",
    "ESP",
    "FIN",
    "BEL",
    "FRA",
    "ITA",
    "NLD",
    "NOR",
    "CZE",
    "POL",
    "IRL",
    "HUN",
    "GRC",
    "ROU",
    "PRT",
  ],
  CAN: ["CAN"],
};

export const TRANSLATED_DAYS = [
  {
    label: "day.sunday",
  },
  {
    label: "day.monday",
  },
  {
    label: "day.tuesday",
  },
  {
    label: "day.wednesday",
  },
  {
    label: "day.thursday",
  },
  {
    label: "day.friday",
  },
  {
    label: "day.saturday",
  },
];

export const TRANSLATED_MONTHS = [
  {
    label: "month.january",
  },
  {
    label: "month.february",
  },
  {
    label: "month.march",
  },
  {
    label: "month.april",
  },
  {
    label: "month.may",
  },
  {
    label: "month.june",
  },
  {
    label: "month.july",
  },
  {
    label: "month.august",
  },
  {
    label: "month.september",
  },
  {
    label: "month.october",
  },
  {
    label: "month.november",
  },
  {
    label: "month.december",
  },
];

export const BUS_SETTINGS_TYPES = {
  DEALER: "DEALER",
  NSC: "NSC",
  MARKET: "MARKET",
};

export const BLUESNAP_MARKETS = []; // NLD migrated to Stripe
export const STRIPE_MARKETS = [
  "AUT",
  "DEU",
  "GBR",
  "ITA",
  "BEL",
  "CZE",
  "FIN",
  "GRC",
  "HUN",
  "IRL",
  "POL",
  "PRT",
  "ROU",
  "ESP",
  "NOR",
  "CHE",
  "FRA",
  "NLD", // Migrated from BlueSnap to Stripe
];
export const VISTA_NUMBER = "vistaNumber";
export const ORBIT_NUMBER = "orbitNumber";
export const LAST_NAME = "lastName";
export const VEHICLE_RESERVATION_FLOW_DIAGRAM_URL =
  "https://azureford.sharepoint.com/:p:/r/sites/digitalactionhubeu/Shared%20Documents/How%20Online%20Sales%20Works/eComm%20Vehicle%20Reservation%20Flow.pptx?d=wcb26cbda2cea4d4bae1b9d0d5519b803&csf=1&web=1&e=dbMVRi";
export const E_COMMERCE_ISSUE_REPORT_FORM_URL =
  "https://www.itconnect.ford.com/catalog/ecom/issue";
export const ALD_MARKET_LIST = ["GBR", "FRA", "DEU", "NLD", "ESP", "ITA"];

export const DOCUMENT_REASON = {
  10: "certificateOfRegistrationDocumentsReceivedAreIllegible",
  20: "certificateOfRegistrationIncorrectRegisteredKeeper",
  30: "certificateOfRegistrationNotSuppliedMissingDocument",
  40: "dealerInvoiceDealerDetailsMissingQuery",
  50: "dealerInvoiceDocumentsReceivedAreIllegible",
  60: "dealerInvoiceIncorrectDueFrom",
  70: "dealerInvoiceManualAmendmentsOnDealerInvoicesNeedDealerStampAndSignature",
  80: "dealerInvoiceMissingPages",
  90: "dealerInvoiceNotInvoicedToCorrectly",
  100: "dealerInvoiceNotSuppliedMissingDocument",
  110: "dealerInvoiceVehicleCostingFiguresQuery",
  120: "dealerInvoiceVehicleDetailsQuery",
  130: "deliveryNoteDeliveryDateMissing",
  140: "deliveryNoteDeliveryMileageQuery",
  150: "deliveryNoteDocumentsReceivedAreIllegible",
  160: "deliveryNoteNotSignedByTheCustomer",
  170: "deliveryNoteNotSuppliedMissingDocument",
};

export const CONSUMER_TYPE = ["Personal", "Business"];
